<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Registrarse</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form class="ma-4" ref="form">
              <v-text-field
                v-model="firstname"
                label="Nombre"
                name="firstname"
                prepend-icon="person"
                type="text"
                placeholder="Nombre"
                autocomplete="off"
              ></v-text-field>
              <v-text-field
                v-model="lastname"
                label="Apellido"
                name="lastname"
                prepend-icon="person"
                type="text"
                placeholder="Apellido"
                autocomplete="off"
              ></v-text-field>
              <v-text-field
                v-model="company"
                label="Empresa"
                name="company"
                prepend-icon="business"
                type="text"
                placeholder="Empresa"
                autocomplete="off"
              ></v-text-field>
              <v-text-field
                v-model="email"
                label="Email"
                name="email"
                prepend-icon="email"
                type="email"
                placeholder="Email"
                autocomplete="off"
              ></v-text-field>
              <v-text-field
                v-model="password"
                label="Contraseña"
                name="password"
                prepend-icon="lock"
                type="password"
                placeholder="Contraseña"
                autocomplete="off"
                :rules="passwordRules"
              ></v-text-field>
              <v-text-field
                v-model="repassword"
                label="Confirmar Contraseña"
                name="password"
                prepend-icon="lock"
                type="password"
                placeholder="Confirmar Contraseña"
                autocomplete="off"
                :rules="repasswordRules"
              ></v-text-field>
              <v-alert v-if="error" type="error">
                {{ error }}
              </v-alert>
              <v-checkbox
                v-model="terms"
                label="Acepto los terminos y condiciones"
                :rules="termsRules"
              ></v-checkbox>
              <div class="d-flex justify-end">
                <div class="mt-2 ml-1">
                  Ya tienes una cuenta?
                  <router-link to="login">Inicia sesión</router-link>
                </div>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  class="text-capitalize"
                  @click.prevent="register"
                  >Registrarse</v-btn
                >
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      firstname: "",
      lastname: "",
      company: "",
      email: "",
      password: "",
      repassword: "",
      terms: false,
      passwordRules: [(v) => (!!v && v.length > 8) || "Al menos 8 carácteres"],
      repasswordRules: [
        (v) => (!!v && v.length > 8) || "Al menos 8 carácteres",
        (v) => this.password === v || "Los passwords deben ser iguales",
      ],
      termsRules: [(v) => v || "Debes aceptar los terminos"],

      error: null,
    };
  },
  methods: {
    register() {
      if (this.$refs.form.validate()) {
        const { firstname, lastname, company, email, password } = this;
        this.$http
          .post("/api/register", {
            firstname,
            lastname,
            company,
            email,
            password,
          })
          .then((response) => {
            console.log(response);
            if (response.data.status == "ok") {
              this.error = null;
              this.$router.push({ path: "/login" });
            }else if (response.data.status == "error") {
              this.error = response.data.message
            }
          });
      }
    },
  },
};
</script>